import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteValuePipe } from './autocomplete.pipe';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [AutocompleteComponent, AutocompleteValuePipe],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconModule],
  exports: [AutocompleteComponent, AutocompleteValuePipe],
})
export class AutocompleteModule {}
